<template>
  <div id="view-login">
    <div>
      <div id="logo" @click="goHome" />
    </div>

    <sui-grid class="middle aligned center aligned">
      <br>
      <sui-container text-align="left">
        <h2 as="sui-header" align="center" inverted>{{ $t('passwordResetToken') }}:</h2>
        <sui-segment class="smallSegment">
          <sui-form>
            <sui-form-field>
              <label></label>
              <sui-input icon-position="left" icon="envelope" name="email" type="text" :placeholder="$t('email')" v-model="current.email" />
              <sui-input v-if="showInsertToken" icon-position="left" icon="key" name="token" type="text" :placeholder="$t('token')" v-model="current.token" />
              <sui-input v-if="showInsertToken" icon-position="left" icon="lock" name="token" type="password" :placeholder="$t('password')" v-model="current.password" />
              <sui-input v-if="showInsertToken" icon-position="left" icon="lock" name="token" type="password" :placeholder="$t('confirmPassword')" v-model="current.password_confirmation" />
            </sui-form-field>
            <sui-button @click.prevent="clickButton" color="red" fluid>{{ $t('request') }}</sui-button>
          </sui-form>

          <sui-dimmer :active="loading">
            <sui-loader>{{ $t('loading') }}</sui-loader>
          </sui-dimmer>
        </sui-segment>

        <sui-segment class="smallSegment" style="text-align:center">
          {{$t('tokenAlready' + showInsertToken)}} <a @click.prevent="toggleShowInsert">{{$t("toggleInsertToken"+showInsertToken)}}</a><br>
          {{$t('remberedPass')}} <router-link to="/login">{{$t("gotoLogin")}}</router-link>
          
        </sui-segment>
      </sui-container>
    </sui-grid>

  </div>
</template>

<script>
import ApiService from "@/services/ApiService.js"
export default {
	data() {
      return {
        loading: false,
        showInsertToken: false,
        result: {
          valid: false,
          voucherPlus: false,
          tarif: '',
          timeLeft: 0,
          dataLeft: 0,
          min: '',
          max: ''
        },
        current: {}
      }
    },
	methods: {
		async requestPassword(){
			let res = await ApiService.requestToken({email:this.current.email})
			if(res.status == 200){
				this.showInsertToken = true
			}else{
				this.$swal({
					icon: "error",
					title: this.$t("error"),
					message: this.$t(res.data)
				})
			}
		},
		async verifyToken(){
			if(this.current.password != this.current.password_confirmation){
				this.$swal({
					icon: "error",
					title: this.$t("error"),
					message: this.$t("passwordMustFit")
				})
				return;
			}
			let res = await ApiService.changePassWithToken({email:this.current.email,token:this.current.token,password:this.current.password})
			if(res.status == 200){
				this.$swal({
					icon: "success",
					title: this.$t("yea"),
					message: this.$t("passwordChanged")
				})
				this.showInsertToken = false
			}else{
				this.$swal({
					icon: "error",
					title: this.$t("error"),
					message: this.$t(res.data)
				})
			}
		},
		toggleShowInsert(){
			this.showInsertToken = !this.showInsertToken
		},
		clickButton(){
			this.showInsertToken ? this.verifyToken() : this.requestPassword()
		},
		goHome(){
			this.$router.push("/")
		}
	},
}
</script>

<style lang="scss" scoped>
  h2 {
    color: #fff;
  }
  #logo {
    background-image: url(../assets/img/logo-shell-white.png);
    background-repeat: no-repeat;
    background-size: 80px 56px;
    height: 71px;
    left: 5px;
    margin: 10px auto;
    position: relative;
    top: 5px;
    width: 858px;
    cursor: pointer;
  }

  #banner {
    background-image: url(../assets/img/banner_online.png);
    width: 477px;
    height: 156px;
    background-repeat: no-repeat;
    margin: 0 auto 1em;
    position: relative;
    top: 0px;
  }
  .smallSegment {
    max-width: 450px;
    margin: 0 auto 10px !important;
  }
  #view-login{
    overflow-x: hidden;
    overflow-y: hidden;
  }
</style>